<template>
  <draggable v-model="items" filter=".signature.wrapper" @end="onEnd" class="row">
    <b-col v-for="(item, index) in items" :key="index" :class="`${item.span_row ? 'col-12' : getColClass(item)} mb-2`">
      <div class="block-wrapper h-100" @dblclick="blockOnDblClick(item, index)">
        <page-one-column-block
          v-if="item.type == 'one-column'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-one-column-block>
        <page-hero-block
          v-if="item.type == 'hero'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-hero-block>
        <page-card-block
          v-if="['card', 'form-card', 'document-card', 'location-card', 'package-card', 'am-class-card', 'staff-login-link'].indexOf(item.type) >= 0"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-card-block>
        <page-calendar-block
          v-if="item.type == 'calendar'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-calendar-block>
        <page-amilia-block
          v-if="['amilia-program', 'amilia-activity', 'amilia-membership'].indexOf(item.type) >= 0 && !item.meta"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-amilia-block>
        <page-amilia-program-block
          v-if="item.type == 'amilia-program' && !!item.meta"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-amilia-program-block>
        <page-amilia-membership-block
          v-if="item.type == 'amilia-membership' && !!item.meta"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-amilia-membership-block>
        <page-amilia-activity-block
          v-if="item.type == 'amilia-activity' && !!item.meta"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-amilia-activity-block>
        <page-amilia-activity-list-block
          v-if="item.type == 'amilia-activity-list'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-amilia-activity-list-block>
        <page-tile-block
          v-if="item.type == 'tile'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-tile-block>
        <page-video-tile-block
          v-if="item.type == 'video-tile'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-video-tile-block>
        <page-video-card-block
          v-if="item.type == 'video-card'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-video-card-block>
        <page-my-account-link-block
          v-if="item.type == 'my-account-link'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-my-account-link-block>
        <EcommerceTabs
          v-if="item.type == 'ecommerce'"
          :organization="organization"
          :block="item"
        />
        <page-bookings-block
          v-if="item.type == 'bookings'"
          :organization="organization"
          :page="page"
          :block="item"
        >
          <slot name="bookings"></slot>
        </page-bookings-block>
        <page-products-block
          v-if="item.type == 'products'"
          :organization="organization"
          :page="page"
          :block="item"
        >
          <slot name="products"></slot>
        </page-products-block>
        <PageFormAnswersBlock
          v-if="item.type == 'form-answers'"
          :organization="organization"
          :page="page"
          :block="item"
        ></PageFormAnswersBlock>
        <page-team-standings-block
          v-if="item.type == 'team-standings'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-team-standings-block>
        <page-teams-schedule-block
          v-if="item.type == 'teams-schedule'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-teams-schedule-block>
        <page-player-stats-block
          v-if="item.type == 'player-stats'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-player-stats-block>
        <page-attendance-block
          v-if="item.type == 'attendance'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-attendance-block>
        <page-radio-buttons-block
          v-if="item.type == 'radio-buttons'"
          :organization="organization"
          :page="page"
          :block="item"
        ></page-radio-buttons-block>
        <PageHtmlBlock
          v-if="item.type == 'html'"
          :block="item"
        />
        <PageAlertBlock
          v-if="item.type == 'alert'"
          :page="page"
          :block="item"
        />
        <PageSearchBlock
          v-if="item.type == 'search'"
          :organization="organization"
          :page="page"
          :block="item"
        />
        <PageTabsBlock
          v-if="item.type == 'tabs'"
          :organization="organization"
          :page="page"
          :block="item"
        />
        <PageTableBlock
          v-if="item.type == 'table'"
          :organization="organization"
          :page="page"
          :block="item"
        />
        <PageLinksBlock
          v-if="item.type == 'links'"
          :organization="organization"
          :page="page"
          :block="item"
        />
        <PageAudioBlock
          v-if="item.type == 'audio'"
          :organization="organization"
          :page="page"
          :block="item"
        />
        <b-dropdown
          v-if="organization.is_editing_microsite"
          :id="`block-menu-${index}`"
          variant="outline-primary"
          toggle-class="edit px-2"
          style="position: absolute; right: 1.5em; top: 0.75em; z-index: 100;"
          no-caret
          right
          @click.stop
        >
          <template #button-content>
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item @click="$emit('click-modify', item, index)">
            <i class="fa fa-fw fa-edit"></i>
            {{ trans('edit') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="canDuplicate(item)" @click="$emit('click-duplicate', item, index)">
            <i class="fa fa-fw fa-copy"></i>
            {{ trans('duplicate') }}
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('click-delete', item, index)">
            <span class="text-danger">
              <i class="fa fa-fw fa-trash"></i>
              {{ trans('remove') }}
            </span>
          </b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-header>
            {{ trans('add') }}
          </b-dropdown-header>
          <b-dropdown-item @click="$emit('click-add-before', item, index)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('before') }}
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('click-add-after', item, index)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('after') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-col>
  </draggable>
</template>

<script>
import PageOneColumnBlock from './PageOneColumnBlock'
import PageHeroBlock from './PageHeroBlock'
import PageCalendarBlock from './PageCalendarBlock'
import PageCardBlock from './PageCardBlock'
import PageTileBlock from './PageTileBlock'
import PageVideoTileBlock from './PageVideoTileBlock'
import PageVideoCardBlock from './PageVideoCardBlock'
import PageAmiliaBlock from './PageAmiliaBlock'
import PageAmiliaProgramBlock from './PageAmiliaProgramBlock'
import PageAmiliaMembershipBlock from './PageAmiliaMembershipBlock'
import PageAmiliaActivityBlock from './PageAmiliaActivityBlock'
import PageAmiliaActivityListBlock from './PageAmiliaActivityListBlock'
import PageMyAccountLinkBlock from './PageMyAccountLinkBlock'
import PageBookingsBlock from './PageBookingsBlock'
import PageProductsBlock from './PageProductsBlock'
import EcommerceTabs from '../microsite/EcommerceTabs'
import PageFormAnswersBlock from './PageFormAnswersBlock'
import PageTeamStandingsBlock from './PageTeamStandingsBlock'
import PageTeamsScheduleBlock from './PageTeamsScheduleBlock'
import PagePlayerStatsBlock from './PagePlayerStatsBlock'
import PageHtmlBlock from './PageHtmlBlock'
import PageAttendanceBlock from './PageAttendanceBlock'
import PageRadioButtonsBlock from './PageRadioButtonsBlock'
import PageSearchBlock from './PageSearchBlock'
import PageAlertBlock from './PageAlertBlock'
import PageTabsBlock from './PageTabsBlock'
import PageTableBlock from './PageTableBlock'
import PageLinksBlock from './PageLinksBlock'
import PageAudioBlock from './PageAudioBlock'

export default {
  props: {
    organization: Object,
    page: Object,
    blocks: Array,
  },
  components: {
    PageOneColumnBlock,
    PageHeroBlock,
    PageCalendarBlock,
    PageCardBlock,
    PageAmiliaBlock,
    PageAmiliaProgramBlock,
    PageAmiliaMembershipBlock,
    PageAmiliaActivityBlock,
    PageAmiliaActivityListBlock,
    PageTileBlock,
    PageVideoTileBlock,
    PageVideoCardBlock,
    PageMyAccountLinkBlock,
    PageBookingsBlock,
    PageProductsBlock,
    EcommerceTabs,
    PageFormAnswersBlock,
    PageTeamStandingsBlock,
    PageTeamsScheduleBlock,
    PagePlayerStatsBlock,
    PageAttendanceBlock,
    PageRadioButtonsBlock,
    PageHtmlBlock,
    PageSearchBlock,
    PageAlertBlock,
    PageTabsBlock,
    PageTableBlock,
    PageLinksBlock,
    PageAudioBlock
  },
  data() {
    return {
      trans: trans,
      getColClass: _.getColClass,
      busy: false,
      error: null,
      items: _.cloneDeep(this.blocks),
      timeoutId: null,
    }
  },
  watch: {
    blocks() {
      this.items = _.cloneDeep(this.blocks)
    },
  },
  methods: {
    canDuplicate(item) {
      return ['my-account-link', 'bookings', 'products'].indexOf(item.type) === -1
    },
    onEnd() {
      this.$emit('reorder', _.map(this.items, 'id'))
    },
    blockOnDblClick(item, index) {
      if (item.type == 'calendar') return
      this.$emit('click-modify', item, index)
    }
  },
  mounted() {
    window.pageBlocks = this
  },
}
</script>
